import React from "react";
import utils from "../../utils/utils";
import SVGraphics from "../../assets/SVGraphics";

const Tab = ({ tab, index, activeTabIndex, handleTabClick, removeTab }) => {
  return (
    <div
      key={index}
      className={` cursor-pointer flex w-[246px] pt-[3px] px-[10px] justify-between text-[12px] items-center border-r-[#484848] border-r-[1px] ${
        activeTabIndex !== index ? "bg-transparent" : "bg-[#111111]"
      } text-white`}
      onClick={() => handleTabClick(tab, index)}
    >
      <div className="flex gap-[10px]">
        <SVGraphics
          svgname={`${
            tab.page === "patient" ? "PatientTabIcon" : "PatientTabIcon"
          }`}
          className={"w-[17px]"}
        />
         {(<div>{utils.insertDash(tab.id)}</div>)}
      </div>

      {/* <div>{utils.insertDash(tab.id)}/{utils.insertDash(tab.examId)}</div> */}


      <SVGraphics
        svgname={"TabClose"}
        className={" cursor-pointer"}
        onClick={(e) => {
          e.stopPropagation(); // Prevent the event from reaching handleTabClick
          removeTab(tab); // Call the removeTab function
        }}
       width='7px'
       height='7px'
      />
    </div>
  );
};

export default Tab;
